import PostRequest from "csi/comm/PostRequest";
import locale from "csi/locale";
import New from "csi/table/New";
import util from "csi/util";
import declare from "dojo/_base/declare";
import { SUPPORTED_FILE_EXTENSION } from "./DGaaSForm";

const DGaasController = declare(New, {
	/**
	 * @override
	 * Set the parameters to the call method DGaaS UploadTemplate
	 */
	process() {
		const fd = this.getFormData();
		const req = new PostRequest("DocumentGenerator", "UploadTemplate");

		const primaryTypeValue = fd.getFieldValue("PrimaryType");
		const primarySubtype = fd.getFieldValue("PrimarySubtype");
		const templateName = fd.getFieldValue("Node Name");

		req.addParameter("TemplateName", templateName);
		req.addParameter("PrimaryType", primaryTypeValue);
		req.addParameter("PrimarySubtype", primarySubtype);
		req.addFiles(fd.getFieldValueAsFile("SourceFile"), "SourceFile");
		this.waitForPublish(req.post());
	},

	/**
	 * @override
	 * Validates the attached file when saving.
	 * Ensures that only files with the '.docx' extension are supported.
	 */
	onValidate() {
		const fd = this.getFormData();
		const fileToRead = fd.getFieldValue("SourceFile");
		const ext = util.getFileExtension(fileToRead);
		if (!SUPPORTED_FILE_EXTENSION.includes(ext)) {
			throw new Error(locale.resource("UnsupportedDGaaSTemplateFile"));
		}
	},

	/**
	 * @override
	 *  Return newly created DGaaSTemplate
	 */
	getNewNodes() {
		if (!this.m_response) {
			return this.inherited(arguments);
		}
		return this.m_response.getNodesOfType("DGaaSTemplate");
	},

	/**
	 * @override
	 * Hide the Save & Go button on the form
	 */
	_canNavigate(): boolean {
		return false;
	},

	/**
	 * @override
	 * Hide the Save & new button on the form
	 */
	_canRepeat(): boolean {
		return false;
	},

});
export = DGaasController;
